/* esm.sh - applesauce-common@5.2.0/blueprints/app-data */
export * from "/*applesauce-common@5.2.0/esnext/blueprints/app-data.mjs";
